import { memo } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { Link } from "react-router-dom";

function Hospitalinfo() {
  const path = window.location.pathname;

  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            {path === "/" && (
              <div className="col-md-6 hospalin">
                <div className="hospitalin">
                  <h6>ABOUT US</h6>
                  <h1>Ultimate Health Care and expertize</h1>
                  <>
                    <p style={{ textAlign: "justify" }}>
                      Viksha Health Care is a modern multispecialty clinic
                      located in J.P. Nagar, Bengaluru, offering advanced
                      medical care with a patient-first approach. Equipped with
                      state-of-the-art facilities and supported by experienced
                      specialists, we are committed to delivering accurate
                      diagnosis, effective treatment, and compassionate care.
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      Our orthopaedic services are led by Dr. Chethan Kumar R, a
                      skilled orthopaedic surgeon specializing in joint
                      replacement, trauma, and sports injuries, with advanced
                      training from Fortis Hospital. At Viksha, we combine
                      expertise and technology to help you move better, recover
                      faster, and live healthier.
                    </p>
                  </>
                  <h2 style={{ fontSize: "0px" }}>
                    Best multispecialty hospital in JP Nagar
                  </h2>
                  {path === "/" && (
                    <div>
                      <div className="hospbar"></div>
                      <Link to="/about" className="hoslink">
                        <h6>MORE ABOUT US</h6>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            )}
            {path === "/about" && (
              <div className="col-md-6 hospalin">
                <div className="hospitalin">
                  <h6>ABOUT US</h6>
                  <h1>Ultimate Health Care and expertize</h1>
                  <>
                    <p style={{ textAlign: "justify" }}>
                      Viksha is a multispecialty clinic equipped with
                      state-of-the-art, world-class facilities, located at 95,
                      15th Main, 17th Cross Road, 5th Phase, J. P. Nagar,
                      Bengaluru, Karnataka. At Viksha, we bring together
                      exceptionally talented specialists and advanced medical
                      technology to provide comprehensive and high-quality
                      healthcare services. Our focus is on delivering
                      personalized treatment and ensuring the best possible
                      health outcomes for every patient. Visit us today for
                      expert care at one of the best multispecialty clinics near
                      Jayanagar.
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      Leading our orthopaedic services is Dr. Chethan Kumar R,
                      an experienced orthopaedic surgeon specializing in joint
                      replacement, trauma care, and sports-related injuries. He
                      has completed a fellowship in joint replacement surgery
                      from Fortis Hospital and was a meritorious student,
                      earning top ranks during his MBBS and MS Orthopaedics
                      entrance examinations. He has also completed the AO
                      Advanced Trauma Course, further strengthening his
                      expertise in managing complex orthopaedic conditions.
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      Dr. Chethan Kumar R is skilled in treating primary and
                      complex trauma cases and performing advanced procedures
                      such as primary hip and knee joint replacements, navigated
                      knee joint replacements, and revision joint replacement
                      surgeries. He also has extensive experience in sports
                      injury management, including ACL reconstruction, Bankart
                      repair, and meniscus repair, helping patients return to
                      active lifestyles safely.
                    </p>
                  </>
                  <h2 style={{ fontSize: "0px" }}>
                    Best multispecialty hospital in JP Nagar
                  </h2>
                </div>
              </div>
            )}
            {path === "/" && (
              <div className="col-md-6 hosimg">
                <img src="/photo/about-img.jpg" alt="" />
              </div>
            )}
            {path === "/about" && (
              <div className="col-md-6 hosimg">
                <img
                  src="/photo/about-us.jpg"
                  style={{ width: "100%", height: "100%",objectFit:"contain" }}
                  alt=""
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
export default memo(Hospitalinfo);
